<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/kaisu/mrp/detail/page"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini"  :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('MRPdanhao')">
            <el-input disabled v-model="$attrs.mrpOrder.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuadanhao')">
            <el-input disabled v-model="$attrs.mrpOrder.planNo"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinmingcheng')">
            <yi_cross_select disabled multiple  :component="'web_base_matter_list'" :ids.sync="$attrs.mrpOrder.materialId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item  :label="$t('MRPzhuangtai')">
            {{mpOrderStatus}}
<!--            {{$t(store.state.dictJsonAll['KAISU_MRP_HEAD_STATUS'][mpOrderStatus])}}-->
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <!-- <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
        </el-button>
      </template> -->
      <!-- 自定义某个字段 -->
      <template #MESsanweibianma="scope">
        <template>
          <span>{{scope.row.mesUnit}}/{{$t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.mesUnit])}}</span>
        </template>
      </template>
      <template #WMSdanweibianma="scope">
        <template>
          <span>{{scope.row.wmsUnit}}/{{$t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.wmsUnit])}}</span>
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status==1||scope.row.inOrder==null">
            <el-button :loading="createInOrderLoading" type="text" @click="createInOrder(scope.row)">{{$t('xiafarukudan')}}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status==1||scope.row.outOrder==null">
            <el-button :loading="createOutOrderLoading" type="text" @click="createOutOrder(scope.row)">{{$t('xiafachukudan')}}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status==1">
            <el-button type="text" @click="shortage(scope.row)">{{$t('queliaojisuan')}}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zidianleixing')" required="required">
            <el-select filterable :clearable="true" v-model="yt.editObj.typeId">
              <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zidianzhi')" required="required">
            <el-input v-model="yt.editObj.value" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqian')" required="required">
            <el-input v-model="yt.editObj.label" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shunxu')">
            <!-- <el-input v-model="yt.editObj.priority" maxlength="8" ></el-input> -->
            <yi_number_input :min="1" :type="'number'" @input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g,'')" :start.sync="yt.editObj.priority"></yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST','/web/config/customer/dictionary/item/create')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!--缺料计算-->
      <template v-if="yt.editObj.action == 'queliaojisuan'">
        <div class="dialog-scroller">
          <shortage_calculation  ref="calculationOrder" :calculation="yt.editObj"></shortage_calculation>
        </div>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading" @click="saveCalculation"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!-- 编辑表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zidianleixing')" required="required">
            <el-select filterable :clearable="true" v-model="yt.editObj.typeId" disabled>
              <el-option v-for="(item, index) in dictionaryList" :key="index" :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('zidianzhi')" required="required">
            <el-input v-model="yt.editObj.value" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqian')" required="required">
            <el-input v-model="yt.editObj.label" maxlength="100"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shunxu')">
            <yi_number_input :min="1" :type="'number'" @input="yt.editObj.priority = String(yt.editObj.priority).replace(/[^\d]/g,'')" :start.sync="yt.editObj.priority"></yi_number_input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/config/customer/dictionary/item/update')"
              type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>

    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import shortage_calculation from '@@/pages/web/wms/mrp/mrp_details/shortage_calculation'
export default {
  name: 'web_wms_mrp_details_index',
  components: {
    shortage_calculation
  },
  data() {
    return {
      createInOrderLoading:false,
      createOutOrderLoading:false,
      calculationId:null,
      dictionaryList: [],
      list: [],
      rolesList: [],
      organizationList: [],
      columns: [{
        label: 'wuliaobianma',
        prop: 'material.code',
        width: 130,
      }, {
        label: 'wuliaomingcheng',
        prop: 'material.name',
        width: 150,
      }, {
        label: 'MESsanweibianma',
        prop: 'mesUnit',
        type: 'slot',
        width: 150,
      }, {
        label: 'WMSdanweibianma',
        prop: 'wmsUnit',
        type: 'slot',
        width: 150,
      }, {
        label: 'xuqiushuliang',
        prop: 'demandQuantity',
      },{
        label: 'kucunshuliang',
        prop: 'inventoryQuantity',
        width: 150,
      },
        {
          label: 'queliaoshuliang',
          prop: 'shortageQuantity',
          width: 150,
        },
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'KAISU_MRP_DETAIL_STATUS',
          width: 150,
        },
        {
          label: 'xiafarukudanhao',
          prop: 'inOrder.no',
          width: 150,
        },
        {
          label: 'xiafachukudanhao',
          prop: 'outOrder.no',
          width: 150,
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 150,
        },
        //   {
        //   label: 'gongdanzhuangtai',
        //   type: 'tag',
        //   sort: 'string',
        //   prop: 'status',
        //   width: 130,
        //   tags: {
        //     1: {
        //       color: '#419FFF',
        //       text: this.$t('xinjian')
        //     },
        //     2: {
        //       color: '#419FFF',
        //       text: this.$t('fafang')
        //     },
        //     3: {
        //       color: '#67C23A',
        //       text: this.$t('shengchanzhong')
        //     },
        //   },
        // },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
        },{
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }]
    };
  },
  computed:{
    mpOrderStatus(){
      // 0-待计算、1-缺料、2-库存充足。
      console.log('this.$yt.list11',this.yt.list)
      if(this.yt.list.length==0){
        return  this.$t(this.store.state.dictJsonAll['KAISU_MRP_HEAD_STATUS'][0])
      }
        console.log('this.$yt.list11',this.yt.list)
        if (this.yt.list.every(item => item.status === '2')) {
          //判断数组中每一条数据的status是否都等于2
          const status = 2
          return this.$t(this.store.state.dictJsonAll['KAISU_MRP_HEAD_STATUS'][status]);
        } else if (this.yt.list.some(item => item.status === '1')) {
        //判断数组中是否有一条数据的status是1
          const status = 1
          return this.$t(this.store.state.dictJsonAll['KAISU_MRP_HEAD_STATUS'][status]);
        }else {
          const status = 0
          return this.$t(this.store.state.dictJsonAll['KAISU_MRP_HEAD_STATUS'][status]);
        }

    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        //表格默认按照创建时间降序排序。
        // orderBy: 'createTime desc',
        mrpId: this.$attrs.mrpOrder.id,
      }
      this.yt.get(1);
      // this.yt.get(1,this.beforeGet);
      // this.getDictCatList();
    }, 300)

  },

  methods: {
    // beforeGet(params) {
    //   console.log('params11',params)
    //   params['pageSize'] = 999
    //   return params
    // },
    shortage(row){
      this.yt.showEditDialog('queliaojisuan', row,'80%')
      console.log('rowqwqw',row)
      this.calculationId = row.id
    },
    //
    saveCalculation(){
      let ids = this.$refs['calculationOrder'].ids
      if (ids !== null) {
        let params = {
          warehouseIds: ids,
          id:this.calculationId
        }
        return this.http.post('/custom/kaisu/mrp/detail/shortageCalc', params).then(response => {
          this.utils.successMessage(this.$t(response.msg));
          this.yt.isShowEditDialog = false;
          this.yt.get(1)
        }).catch(error => {
          this.$message.error(error)
        })
      }else {
        this.$message.error(this.$t('qinggouxuanshuju'))
      }
    },
    //下发入库
    createInOrder(row) {
      this.createInOrderLoading =true
      let params = {
        id:row.id,
      }
      this.http.post('/custom/kaisu/mrp/detail/createInOrder', params).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
        this.createInOrderLoading = false
      }).catch(error => {
        this.utils.errorMessage(this.$t(error))
        this.createInOrderLoading = false
      })
    },
    //下发出库
    createOutOrder(row) {
      this.createOutOrderLoading =true
      let params = {
        id:row.id,
      }
      this.http.post('/custom/kaisu/mrp/detail/createOutOrder', params).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
        this.createOutOrderLoading = false
      }).catch(error => {
        this.utils.errorMessage(this.$t(error))
        this.createOutOrderLoading = false
      })
    },
  }
};
</script>
